// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Cart from "@guestsupply/XDL/Icons/Cart";
import OrderApproval from "@guestsupply/XDL/Icons/OrderApproval";
import Print from "@guestsupply/XDL/Icons/Print";
import Save from "@guestsupply/XDL/Icons/Save";
import Trash from "@guestsupply/XDL/Icons/Trash";
import { createLinkIconStyles } from "@guestsupply/XDL/Utilities";
import Plus from "@insite/mobius/Icons/Plus";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { css } from "styled-components";

interface CartPageStyles {
    cartActions?: {
        saveOrderLink?: LinkPresentationProps;
        addAllToListClickable?: LinkPresentationProps;
        removeAll?: LinkPresentationProps;
        printLink?: LinkPresentationProps;
        checkoutLink?: LinkPresentationProps;
        requestQuoteLink?: LinkPresentationProps;
    };
}
const linkIconStyles: LinkPresentationProps = {
    typographyProps: {
        size: 12,
    },
    icon: {
        iconProps: {
            size: 12,
        },
        position: "left",
    },
};

const cartPageStyles: CartPageStyles = {
    cartActions: {
        saveOrderLink: {
            ...createLinkIconStyles(Save, linkIconStyles),
        },
        addAllToListClickable: {
            ...createLinkIconStyles(Plus, {
                ...linkIconStyles,
                icon: {
                    iconProps: {
                        size: 12,
                        css: css`
                            margin-right: 7px;
                        `,
                    },
                    position: "left",
                },
            }),
        },
        checkoutLink: {
            ...createLinkIconStyles(Cart, {
                ...linkIconStyles,
                icon: {
                    iconProps: {
                        size: 12,
                        css: css`
                            margin-right: 7px;
                        `,
                    },
                    position: "left",
                },
            }),
        },
        requestQuoteLink: {
            ...createLinkIconStyles(OrderApproval, {
                ...linkIconStyles,
                icon: {
                    iconProps: {
                        size: 12,
                        css: css`
                            margin-right: 7px;
                        `,
                    },
                    position: "left",
                },
            }),
        },
        removeAll: {
            ...createLinkIconStyles(Trash, linkIconStyles),
        },
        printLink: {
            ...createLinkIconStyles(Print, linkIconStyles),
        },
    },
};

export default cartPageStyles;
